module.exports = __webpack_public_path__ + "media/images/gallery/pn_m-30f78c78e262790d220679e07638e86a.gif";